import React from "react";
import { defaultTitle } from "../config";
import { Helmet } from "react-helmet";

const NotFound = () => (
  <React.Fragment>
    <Helmet>
      <title>Not Found - {defaultTitle}</title>
    </Helmet>
    <div
      style={{
        display: "grid",
        placeContent: "center",
      }}
    >
      <p style={{ fontSize: "1.5rem" }}>Page Not Found</p>
    </div>
  </React.Fragment>
);

export default NotFound;
